module.exports = __webpack_public_path__ + "img/applying.ed4e54c5.png";